module.exports = __webpack_public_path__ + "static/exterior-2-806ea6230606706555d340ec4db55f0f.jpg";